export default __webpack_public_path__ + "static/media/notificationBell.119053ca.gif";